import NepaliDate from 'nepali-date-converter';

export function adToBs(adDate) {
  try {
    const bsDate = NepaliDate.fromAD(adDate);
    return bsDate.format('YYYY-MM-DD'); // BS as string
  } catch (e) {
    return null;
  }
}